import React from "react";
import { useTranslation } from "react-i18next";

import { FilterMenu } from "@common/filterMenu";
import { ResourceStatusFilter } from "./resourceStatusFilter";
import { Props } from "./types";
import styles from "./styles.scss";

function Toolbar({ filter, setFilter }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.toolbar}>
      <p className={styles.title}>{t("obsPage.filters.title")}</p>
      <FilterMenu
        filter={filter}
        setFilter={(nextFilter) => setFilter({ ...filter, ...nextFilter })}
        placeholder={t("obsPage.filters.default")}
        views={[
          "resources",
          "groups",
          "resourceTags",
          "roles",
          "organizationalUnits",
        ]}
        openedViews={["resources"]}
      />
      <ResourceStatusFilter
        resourceStatuses={filter.resourceStatuses}
        select={(resourceStatuses) =>
          setFilter({ ...filter, resourceStatuses })
        }
      />
    </div>
  );
}

export { Toolbar };
